<template>
  <header
    class="oen-ui-card-header"
    :class="{ 'oen-ui-card-header--without-title': !$slots.default }"
  >
    <div class="oen-ui-card-header-left">
      <!-- @slot left: For action buttons-->
      <slot name="left" />
    </div>
    <div class="oen-ui-card-header-title">
      <!-- @slot default: For optional title -->
      <slot />
    </div>
    <div class="oen-ui-card-header-right">
      <!-- @slot right: For action buttons -->
      <slot name="right" />
    </div>
  </header>
</template>

<style scoped>
.oen-ui-card-header {
  @apply p-1;
  @apply border-b border-gray-lighter border-solid;
  @apply justify-center items-center max-w-full;

  @apply flex;

  /* Show on sm up*/
  @screen sm {
    @apply flex;
    @apply pt-7 px-7 pb-5;
    @apply border-none;
  }

  &.oen-ui-card-header--without-title {
    @apply border-none;
    @apply pb-0 -mb-1;
  }

  .oen-ui-card-header-title {
    @apply text-center;
    @apply type-h2;
    @apply truncate;
    @apply h-12;
    /* Using line-height here since we can not guarantee there is a child element, so we avoid flexbox
     https://dev.to/afif/never-make-your-text-container-a-flexbox-container-m9p*/
    line-height: 48px;
    /*Fix width quirk https://css-tricks.com/flexbox-truncated-text/*/
    @apply min-w-0;

    > * {
      @apply truncate max-w-full;
    }
  }

  .oen-ui-card-header-left,
  .oen-ui-card-header-right {
    @apply flex-1;
  }

  .oen-ui-card-header-left {
    @apply flex justify-start;
  }

  .oen-ui-card-header-right {
    @apply flex justify-end;
  }
}
</style>
